import React from 'react';
import { Box, Card, Typography } from '@mui/material';
import CardContent from '@mui/material/CardContent';
import { styled } from '@mui/material/styles';
import src from '../../../../assets/images/home-slider11.png';
import SearchBar from '../SearchBar';
import TrendingHashtag from '../TrendingHashtag';

export const SearchCardContainer = styled(Card)(({ theme }) => ({
  width: '100%',
  height: '560px',
  backgroundImage: `url(${src})`,
  backgroundPosition: '0 100%',
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'cover',
  textAlign: 'center',
  borderRadius: '0',
  [theme.breakpoints.down('sm')]: {
    height: '500px',
  },
}));

export const SearchCard = styled(Box)(() => ({
  height: '100%',
  backgroundColor: 'rgba(0, 0, 0, 0.4)',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
}));

export const SubtitleTypography = styled(Typography)(({ theme }) => ({
  fontFamily: 'Raleway',
  fontSize: '20px',
  fontWeight: 400,
  lineHeight: '23px',
  marginTop: '80px',
  color: '#FFFFFF',
  [theme.breakpoints.down('sm')]: {
    fontSize: '16px',
    lineHeight: '19px',
  },
}));

export const TitleTypography = styled(Typography)(({ theme }) => ({
  fontFamily: 'Fjalla One',
  fontWeight: 400,
  fontSize: '40px',
  lineHeight: '50px',
  color: '#FFFFFF',
  marginTop: '40px',
  [theme.breakpoints.down('sm')]: {
    fontSize: '24px',
    lineHeight: '30px',
    marginTop: '22px',
  },
}));

export default function CafeSearchPanel() {
  return (
    <SearchCardContainer>
      <SearchCard>
        <CardContent>
          <SubtitleTypography>Find out a popular cafe to hangout in your town</SubtitleTypography>
          <TitleTypography>Find an amazing cafe</TitleTypography>
        </CardContent>
        <SearchBar />
        <TrendingHashtag />
      </SearchCard>
    </SearchCardContainer>
  );
}
